// extracted by mini-css-extract-plugin
export default {"container":"WmxVY2M7KT1bv1+CaPiVFw==","scrollable":"DlxaqwIWaoSQp581gtp7Aw=="};